/* global $ */

const $discount = $('.js-discount');
const $input = $('.js-discount-input');
const $trigger = $('.js-discount-trigger');
const $content = $('.js-discount-content');

const discount = {
  initialize() {
    if ($discount.length) {
      this.createListeners();
    }
  },

  createListeners() {
    if ($input.val() !== '') {
      $content.show();
      $trigger.hide();
    }

    $trigger.on('click', () => {
      $content.show();
      $input.focus();
    });
  },
};

export default discount;
